import { render, staticRenderFns } from "./SuiviCA.vue?vue&type=template&id=8c8e39fc&scoped=true&"
import script from "./SuiviCA.vue?vue&type=script&lang=ts&"
export * from "./SuiviCA.vue?vue&type=script&lang=ts&"
import style0 from "./SuiviCA.vue?vue&type=style&index=0&id=8c8e39fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8e39fc",
  null
  
)

export default component.exports